import {canv} from '@/canv/global.js';
import {MakeRequest, getTarget, setClick} from '@/canv/utils.js';

export class navigationSelectWindow {

    constructor() {}


    async open() {

        var navigationSelectWindowWrapper = document.createElement('div');
        navigationSelectWindowWrapper.classList.add("navigationSelectWindowWrapper");
        document.body.prepend(navigationSelectWindowWrapper);

        navigationSelectWindowWrapper.innerHTML += this.getMenu();

        this.init();

    }

    init() {
        setClick("navigationSelectWindowActionsItemAction", this.clickAction.bind(this));

        let navigationSelectWindowModeItem = document.getElementsByClassName("navigationSelectWindowModeItem");
        for (var i = 0; i < navigationSelectWindowModeItem.length; i++) {
            navigationSelectWindowModeItem[i].addEventListener('mousedown', this.itemClick.bind(this), false);
        }
    }


    close() {
        var markWrapper = document.getElementsByClassName("navigationSelectWindowWrapper")[0];
        if (markWrapper != undefined) {
            markWrapper.outerHTML = "";
        }
    }

    itemClick(e) {
        let item = getTarget(e, "navigationSelectWindowModeItem");
        this.mode = item.getAttribute("mode");

        let navigationSelectWindowModeItem = document.getElementsByClassName("navigationSelectWindowModeItem");
        for (var i = 0; i < navigationSelectWindowModeItem.length; i++) {
            navigationSelectWindowModeItem[i].classList.remove("navigationSelectWindowModeItemSelected");
        }

        item.classList.add("navigationSelectWindowModeItemSelected");
    }



    /* Templates */

    getMenu() {
        var template = `
            <div class="navigationSelectWindow">
                <div class="navigationSelectWindowAbout">Выберите режим навигации</div>
                <div class="navigationSelectWindowMode">
                    <div class="navigationSelectWindowModeItem navigationSelectWindowModeItemSelected" mode="mouse">
                        <div class="navigationSelectWindowModeItemIcon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="System / Mouse">
                            <path id="Vector" d="M12 10V7M18 9V15C18 18.3137 15.3137 21 12 21C8.68629 21 6 18.3137 6 15V9C6 5.68629 8.68629 3 12 3C15.3137 3 18 5.68629 18 9Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                            </svg>
                        </div>
                        <div class="navigationSelectWindowModeItemName">Компьютерная мышь</div>
                    </div>
                    <div class="navigationSelectWindowModeItem" mode="trackpad">
                        <div class="navigationSelectWindowModeItemIcon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="System / Bar_Bottom">
                            <path id="Vector" d="M20 15H4M20 15V7.19691C20 6.07899 20 5.5192 19.7822 5.0918C19.5905 4.71547 19.2837 4.40973 18.9074 4.21799C18.4796 4 17.9203 4 16.8002 4H7.2002C6.08009 4 5.51962 4 5.0918 4.21799C4.71547 4.40973 4.40973 4.71547 4.21799 5.0918C4 5.51962 4 6.08009 4 7.2002V15M20 15V16.8031C20 17.921 20 18.48 19.7822 18.9074C19.5905 19.2837 19.2837 19.5905 18.9074 19.7822C18.48 20 17.921 20 16.8031 20H7.19691C6.07899 20 5.5192 20 5.0918 19.7822C4.71547 19.5905 4.40973 19.2837 4.21799 18.9074C4 18.4796 4 17.9203 4 16.8002V15" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                            </svg>
                        </div>
                        <div class="navigationSelectWindowModeItemName">Трекпад</div>
                    </div>
                </div>
                <div class="navigationSelectWindowDescription">Вы сможете поменять режим навигации в любой момент в выпадающем меню рядом с названием доски.</div>
                <div class="navigationSelectWindowActions">
                    <div class="navigationSelectWindowActionsItem navigationSelectWindowActionsItemAction">Готово</div>
                </div>
            </div>
        `;

        return template;
    }

    /* Proccessors */

    async clickAction() {
        canv.actionManager.setMode(this.mode);
        this.close();
    }

    mode = "mouse";

}
